import useSWRMutation from "swr/mutation";
import { axiosInstance } from "../axiosConfig";

const BASE_URL = "/explain";

const useChart = () => {
  const getHomeChartExplanationFetcher = async (
    url: string,
    { arg }: { arg: { type: string; value: number; period: number; periodValue: string } }
  ) => {
    const { type, value, period, periodValue } = arg;
    return axiosInstance.get(
      `${BASE_URL}/${type}/${value}/${period}/${periodValue}`
    );
  };

  const getHomeChartExplanation = useSWRMutation(
    "getHomeChartExplanation",
    getHomeChartExplanationFetcher
  );

  return { getHomeChartExplanation };
};

export default useChart;
